import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import PoDetail from 'components/Po/PoDetail';
// eslint-disable-next-line
export default function PoDetailScreen(): JSX.Element {
  return (
    <ContentLayout>
      <SiteContent>
        <PoDetail />
      </SiteContent>
    </ContentLayout>
  );
}
